import { Button, Popconfirm, Space, Table, Tooltip } from "antd";
import Header from "../../components/Header";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { getOrders } from "../../repository/ordersApi";
import { useEffect, useState } from "react";

const columns = [
  { title: "ID", dataIndex: "id", key: "id" },
  { title: "Order Ref", dataIndex: "order_ref", key: "order_ref" },
  { title: "Date", dataIndex: "date", key: "date" },
  { title: "Session", dataIndex: "session", key: "session" },
  {
    title: "Fiscal Position",
    dataIndex: "fiscal_position",
    key: "fiscal_position",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status) => (status ? "Completed" : "Pending"),
  },
  { title: "User", dataIndex: "User", key: "User" },
  {
    title: "Customer",
    dataIndex: "customer",
    key: "customer",
    render: (customer) => customer ?? "—",
  },
  {
    title: "Payment",
    dataIndex: "payment",
    key: "payment",
    render: (payment) => (payment ? JSON.stringify(payment) : "—"),
  },
  {
    title: "Action",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <Tooltip title="Edit this record">
          <Button
            type="primary"
            size="small"
            icon={<EditOutlined />}
            onClick={() => console.log("Edit clicked", record)}
          >
            Edit
          </Button>
        </Tooltip>

        <Popconfirm
          title="Are you sure you want to delete this record?"
          onConfirm={() => console.log("Deleted", record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Button danger type="primary" size="small" icon={<DeleteOutlined />}>
            Delete
          </Button>
        </Popconfirm>
      </Space>
    ),
  },
];

const SalesDetails = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const data = await getOrders();
      setOrders(data);
      setOrders(data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="d-flex" style={{ height: "100vh" }}>
      {/* Sidebar and Header */}
      <Header />

      {/* Main Content */}
      <div style={{ flex: "11 11 100%", padding: "20px", marginTop: "64px" }}>
        <div className="row ">
          <div className=" col-12">
            <div className="row">
              <div className="col-6">
                <h1 className="text-2xl font-bold">Sales Details</h1>
              </div>
              <div className="col-6 "></div>
            </div>
          </div>
        </div>
        <div className="row p-4">
          <div className="col-12 r-shadow">
            <Table columns={columns} dataSource={orders} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default SalesDetails;
